/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const [showPassword, setShowPassword] = useState(false)

  const handleTogglePassword = () => {
    setShowPassword(!showPassword)
  }
  const passwordInputType = showPassword ? 'text' : 'password'

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await login(values.email, values.password)
        saveAuth(auth)
        // console.log(auth?.data?.token)
        localStorage?.setItem('token', auth?.data?.token)
        // const {data: user} = await getUserByToken(auth.token);
        let auth2 = auth?.data
        let user: any = {
          id: '123456789',
          username: auth2?.profile?.name,
          email: auth2?.profile?.email,
          first_name: auth2?.profile?.name,
          fullname: auth2?.profile?.name,
          phone: auth2?.profile?.phone,
          roles: auth2?.role,
          pic: auth2?.imageFolderPath,
          language: 'en',
        }
        setCurrentUser(user)
      } catch (error: any) {
        console.error(error)
        saveAuth(undefined)
        setStatus(error?.response?.data?.message || 'The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <div
      className='d-flex flex-column flex-lg-row flex-column-fluid h-100'
      style={{background: '#f3f3f3'}}
    >
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px d-flex justify-content-center flex-wrap'>
            <img
              src={toAbsoluteUrl('/media/logos/asteric-white.png')}
              alt='logo'
              height={80}
              className='mb-5'
            />
            <form
              className='form w-100 card p-10'
              onSubmit={formik.handleSubmit}
              noValidate
              id='kt_login_signin_form'
            >
              {/* begin::Heading */}
              <div className='text-center'>
                <h1 className='text-dark fw-regular mb-3'>Login to your account</h1>
                {/* <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
              </div>
              {/* begin::Heading */}
              <hr className='py-3' />
              {/* begin::Login options */}
              {/* <div className='row g-3 mb-9'>
                <div className='col-md-6'>
                  <a
                    href='#'
                    className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
                  >
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
                      className='h-15px me-3'
                    />
                    Sign in with Google
                  </a>
                </div>

                <div className='col-md-6'>
                  <a
                    href='#'
                    className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
                  >
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')}
                      className='theme-light-show h-15px me-3'
                    />
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/svg/brand-logos/apple-black-dark.svg')}
                      className='theme-dark-show h-15px me-3'
                    />
                    Sign in with Apple
                  </a>
                </div>
              </div> */}
              {/* end::Login options */}

              {/* begin::Separator */}
              {/* <div className='separator separator-content my-14'>
                <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
              </div> */}
              {/* end::Separator */}

              {formik.status && (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>{formik.status}</div>
                </div>
              )}

              {/* begin::Form group */}
              <div className='fv-row mb-8'>
                <label className='form-label fs-6 text-dark'>Email address</label>
                <input
                  placeholder='Enter your email address'
                  {...formik.getFieldProps('email')}
                  className={clsx(
                    'form-control bg-transparent',
                    {'is-invalid': formik.touched.email && formik.errors.email},
                    {
                      'is-valid': formik.touched.email && !formik.errors.email,
                    }
                  )}
                  type='email'
                  name='email'
                  autoComplete='off'
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='fv-plugins-message-container'>
                    <span role='alert'>{formik.errors.email}</span>
                  </div>
                )}
              </div>
              {/* end::Form group */}

              {/* begin::Form group */}
              <div className='fv-row mb-3'>
                <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
                <div className='input-group'>
                  <input
                    type={passwordInputType}
                    placeholder='Enter password (min. of 8 characters)'
                    autoComplete='off'
                    {...formik.getFieldProps('password')}
                    className={clsx('form-control bg-transparent', {
                      'is-invalid': formik.touched.password && formik.errors.password,
                    })}
                    defaultValue={formik.values.password}
                  />
                  <button
                    className='btn btn-outline-secondary'
                    type='button'
                    style={{background: '#e8f0fe'}}
                    onClick={handleTogglePassword}
                  >
                    {!showPassword ? (
                      <i className='fa fa-eye'></i>
                    ) : (
                      <i className='fa fa-eye-slash'></i>
                    )}
                  </button>
                </div>
                {formik.touched.password && formik.errors.password && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.password}</span>
                    </div>
                  </div>
                )}
              </div>
              {/* end::Form group */}

              {/* begin::Wrapper */}
              <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold'>
                {/* begin::Link */}
                <Link
                  to='/auth/forgot-password'
                  // className='link-primary'
                  style={{
                    textDecorationLine: 'underline',
                    color: '#000000',
                  }}
                >
                  Forgot Password ?
                  <i
                    className='fa fa-arrow-right'
                    style={{color: 'black', height: '3rem', marginLeft: 5}}
                  ></i>
                </Link>
                {/* end::Link */}
              </div>
              {/* end::Wrapper */}

              {/* begin::Action */}
              <div className='d-grid mb-10'>
                <button
                  type='submit'
                  id='kt_sign_in_submit'
                  className='btn'
                  style={{background: '#454743', color: '#fff', borderRadius: 50}}
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && <span className='indicator-label'>Log in</span>}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Action */}

              <div className='text-black-500 text-center fw-semibold fs-6'>
                Don’t have an Asterics account?{' '}
                <Link
                  to='/auth/registration'
                  style={{color: '#16C782', textDecoration: 'underline'}}
                >
                  Start Free
                </Link>
              </div>
              <div className='text-black-500 text-center fw-semibold fs-6 mt-5'>
                <Link
                  to='/auth'
                  className='font-bold'
                  style={{color: '#16C782', textDecoration: 'none'}}
                >
                  <i className='fa-solid fa-arrow-left'></i> Go Back to Homepage
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
